<template>
  <div class="scrolling-banner">
    <div class="banner-images" ref="banner">
      <!-- 动态渲染图片列表，追加克隆的图片 -->
      <img v-for="(item, index) in extendedList" 
           :key="`${item.id}-${index}`" 
           :src="item.img" 
           :alt="item.alt || ''"
           :class="['banner-img', `img-${index % list.length}`]">
    </div>
  </div>
</template>


<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      validator: value => value.length > 0
    },
    duration: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      extendedList: []
    }
  },
  mounted() {
    // 复制原始图片列表，形成无缝滚动效果
    this.extendedList = [...this.list, ...this.list];
    
    // 监听动画迭代事件来重置位置
    this.$refs.banner.addEventListener('animationiteration', this.resetPosition);
  },
  beforeDestroy() {
    this.$refs.banner.removeEventListener('animationiteration', this.resetPosition);
  },
  methods: {
    resetPosition() {
        // 立即调整位置
        this.$refs.banner.style.transform = `translateX(0)`;
        
        // 强制刷新布局，避免闪烁
        this.$refs.banner.offsetHeight;
        
        // 恢复动画，继续滚动
        this.$refs.banner.style.transition = 'none'; // 禁用过渡动画
        this.$refs.banner.offsetHeight; // 强制刷新
        this.$refs.banner.style.transition = 'transform 10s linear infinite'; // 恢复过渡动画
    }
  }
}
</script>


<style scoped lang="scss">
.scrolling-banner {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.banner-images {
  display: flex;
  align-items: center;
  animation: scroll 20s linear infinite;
  width: max-content;
}

.banner-img {
  object-fit: cover;
  display: block;
  margin: 0 1.25rem; // 转换为rem
  
  // 第一张图片样式
  &.img-0 {
    width: 7.3125rem;
    height: 3.5rem;
  }
  
  // 第二张图片样式
  &.img-1 {
    width: 13.4375rem;
    height: 2rem;
  }
  
  // 第三张图片样式
  &.img-2 {
    width: 5rem;
    height: 3.125rem;
  }
  
  // 第四张图片样式
  &.img-3 {
    width: 8.9375rem;
    height: 4.25rem;
  }
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

</style>
